import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';
import { ExcelExportPayload, ExcelExportModel, ExcelExportItem } from 'common/models/export.model';

// identifier
export const EXCEL_EXPORT_SLICE_ID = 'excelExport';

// default state
const initialState: ExcelExportModel = {};

//slice
const excelExportSlice = createSlice({
  name: EXCEL_EXPORT_SLICE_ID,
  initialState,
  reducers: {
    setExcelExportData: (
      state: ExcelExportModel,
      action: PayloadAction<ExcelExportPayload>
    ): void => {
      const { id, data } = action.payload;
      if (!state[id]) {
        state[id] = [];
      }
      state[id] = data;
    },
    setExcelPartialExportData: (
      state: ExcelExportModel,
      action: PayloadAction<ExcelExportPayload>
    ): void => {
      const { id, data } = action.payload;
      if (!state[`partial_${id}`]) {
        state[`partial_${id}`] = [];
      }
      state[`partial_${id}`] = data;
    },
    extendExcelExportData: (
      state: ExcelExportModel,
      action: PayloadAction<ExcelExportPayload>
    ): void => {
      const { id, data } = action.payload;
      if (!state[id]) {
        state[id] = [];
      }
      state[id] = { ...(state[id] ?? {}), ...(data ?? {}) };
    },
    resetExcelExportData: (state: ExcelExportModel): void => {
      Object.assign(state, {});
    },
    removeExcelExportDataForWidget: (
      state: ExcelExportModel,
      action: PayloadAction<Partial<ExcelExportPayload>>
    ): void => {
      if (action.payload.id) {
        state[action.payload.id] = [];
        delete state[action.payload.id];
      }
    },
  },
});

//selectors

export const selectExcelExportData = (state: RootState) => state.export;

export const selectExcelExportDataById = (state: RootState, id: string): ExcelExportItem[] | null =>
  (state?.excelExport?.[id] ?? null) as ExcelExportItem[] | null;

export const selectPartialExcelExportDataById = (
  state: RootState,
  id: string
): ExcelExportItem[] | null =>
  (state?.excelExport?.[`partial_${id}`] ?? null) as ExcelExportItem[] | null;

//actions
export const {
  setExcelExportData,
  setExcelPartialExportData,
  extendExcelExportData,
  resetExcelExportData,
  removeExcelExportDataForWidget,
} = excelExportSlice.actions;

//reducer
export default excelExportSlice;
